module.exports = __webpack_public_path__ + "img/LF003-03.9cba73fa.jpg";